import { render, staticRenderFns } from "./ServiceFormDpdFields.vue?vue&type=template&id=47ff1a99"
import script from "./ServiceFormDpdFields.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceFormDpdFields.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiAutocomplete: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/components/ui/UiAutocomplete.vue').default})
